<ng-container *ngIf="(currentUser$ | async) as currentUser">
<table class="table table-striped" [class.table-hover]="currentUser && currentUser.admin">
  <thead>
  <tr>
    <th>{{ 'home.users.overview.table.head.userName' | translate }}</th>
    <th>{{ 'home.users.overview.table.head.lastName' | translate }}</th>
    <th>{{ 'home.users.overview.table.head.firstName' | translate }}</th>
    <th class="role">{{ 'home.users.overview.table.head.isAdmin' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngIf="users.length > 0; else noEntries">
    <tr *ngFor="let user of users" (click)="currentUser && currentUser.admin && onEditUser(user)">
      <td>{{ user.userName }}</td>
      <td>{{ user.lastName }}</td>
      <td>{{ user.firstName }}</td>
      <td class="role">
        <ng-container *ngIf="!user.admin" class="">
          <i class="fas fa-times fa-lg red"></i>
        </ng-container>
        <ng-container *ngIf="user.admin" class="">
          <i class="fas fa-check fa-lg green"></i>
        </ng-container>
      </td>
    </tr>
  </ng-container>
  <ng-template #noEntries>
    <tr>
      <td colspan="5">
        {{ 'home.users.overview.table.no-entries' | translate }}
      </td>
    </tr>
  </ng-template>
  </tbody>
</table>
</ng-container>
